import { useTranslation } from "react-i18next";
import clsx from "clsx";
import type { PageScaleInfoProps } from "./types";

/**
 * Current page scale shown next to the groups summary, e.g.
 * "Page Scale 0.0578 m/pt • AI Detected". Hidden while uncalibrated.
 */
export const PageScaleInfo = ({ scale, source }: PageScaleInfoProps) => {
  const { t } = useTranslation();

  if (!source || scale <= 0) return null;

  const formattedScale = parseFloat(scale.toFixed(4));
  const isManual = source === "manual";
  const sourceLabel = isManual
    ? t("smartSurveyor.pageCalibration.sourceUserSet")
    : t("smartSurveyor.pageCalibration.sourceAiDetected");

  return (
    <span className="inline-flex items-center gap-2 rounded-md bg-gray-100 px-2.5 py-1 text-xs">
      <span className="font-medium text-gray-600">
        {t("smartSurveyor.pageCalibration.scaleLabel")}
      </span>
      <span className="font-semibold tabular-nums text-gray-800">
        {t("smartSurveyor.pageCalibration.scaleValue", {
          value: formattedScale,
        })}
      </span>
      <span
        className={clsx(
          "inline-flex items-center gap-1.5 font-medium",
          isManual ? "text-emerald-600" : "text-blue-600",
        )}
      >
        <span
          className={clsx(
            "h-1.5 w-1.5 rounded-full",
            isManual ? "bg-emerald-500" : "bg-blue-500",
          )}
        />
        {sourceLabel}
      </span>
    </span>
  );
};
